import { type PartialDeep } from 'type-fest';

import {
  type BorderRadiusValue,
  type ImageShape,
  type ListCustomFieldLabelBehavior,
  type ListDirectionMode,
} from '@blaze-shared/elements-domain';
import { type ValueWithUnitOfMeasure } from '@blaze-shared/shared-util';

import { type ListImagePropertiesModel } from './list.models';

export interface ListTemplateImageContext {
  currentImage: PartialDeep<ListImagePropertiesModel>;
  backgroundRadius: BorderRadiusValue;
  elementOutlineColor: string;
}

export function resolveListTemplateImage(
  direction: ListDirectionMode,
  context: ListTemplateImageContext,
): PartialDeep<ListImagePropertiesModel> {
  switch (direction) {
    case 'subscription-plan':
    case 'vertical':
      return {
        ...context.currentImage,
        shape: 'landscape-short',
        radius: '0px',
        padding: resolveListImagePadding(direction, 'landscape-short'),
      };
    case 'horizontal':
    case 'notification':
      return {
        ...context.currentImage,
        shape: 'square',
        radius: context.backgroundRadius,
        padding: resolveListImagePadding(direction, 'square'),
      };
    case 'e-commerce':
      return {
        shape: 'landscape-short',
        radius: context.backgroundRadius,
        outline: {
          color1: context.elementOutlineColor || '$t.outline',
          selectorType: 'solid',
        },
        outlineWidth: '1px',
        padding: resolveListImagePadding(direction, 'landscape-short'),
      };
    default:
      return {};
  }
}

export function resolveListImagePadding(
  direction: ListDirectionMode | undefined,
  shape: ImageShape | undefined,
): ValueWithUnitOfMeasure {
  switch (direction) {
    case 'vertical':
    case 'subscription-plan':
      return shape === 'circle' ? '16px' : '0px';
    case 'e-commerce':
      if (shape === 'circle') {
        return '16px';
      }
      if (shape === 'square') {
        return '8px';
      }
      return '0px';
    default:
      return '0px';
  }
}

export function customFieldLabelPositionForDirection(
  direction: ListDirectionMode,
): ListCustomFieldLabelBehavior {
  return direction === 'notification' ? 'left' : 'top';
}
